var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#EBF1F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7158 54.567C31.7158 54.9458 31.8663 55.3091 32.1341 55.5769C32.402 55.8448 32.7653 55.9952 33.1441 55.9952H38.8571C39.2359 55.9952 39.5992 55.8448 39.8671 55.5769C40.1349 55.3091 40.2854 54.9458 40.2854 54.567V51.7104H31.7158V54.567Z",
    fill: "#3374B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3712 16.0942C31.5982 16.4106 28.9788 17.5332 26.8371 19.3229C24.6955 21.1126 23.1256 23.491 22.3217 26.1637C21.5178 28.8365 21.5151 31.6863 22.3141 34.3605C23.1131 37.0347 24.6786 39.416 26.8169 41.2096C27.4554 41.7442 27.9691 42.4121 28.3219 43.1664C28.6747 43.9207 28.858 44.743 28.8589 45.5758V47.4257C28.8589 47.8045 29.0094 48.1678 29.2772 48.4356C29.5451 48.7035 29.9084 48.8539 30.2872 48.8539H41.7133C42.0921 48.8539 42.4554 48.7035 42.7232 48.4356C42.9911 48.1678 43.1415 47.8045 43.1415 47.4257V45.5757C43.1379 44.7507 43.3154 43.9349 43.6616 43.186C44.0078 42.4372 44.5142 41.7735 45.1451 41.2418C47.5068 39.2743 49.1703 36.597 49.8881 33.6082C50.606 30.6193 50.3399 27.4786 49.1294 24.6531C47.9189 21.8277 45.8287 19.4684 43.1696 17.9263C40.5106 16.3842 37.4248 15.7417 34.3712 16.0942ZM36.0002 23.1452C34.1069 23.1474 32.2918 23.9005 30.953 25.2393C29.6142 26.5781 28.8611 28.3932 28.8589 30.2865C28.8589 30.6653 28.7084 31.0286 28.4406 31.2965C28.1727 31.5643 27.8095 31.7148 27.4307 31.7148C27.0519 31.7148 26.6886 31.5643 26.4207 31.2965C26.1529 31.0286 26.0024 30.6653 26.0024 30.2865C26.0055 27.6359 27.0598 25.0947 28.9341 23.2204C30.8084 21.3461 33.3496 20.2918 36.0002 20.2887C36.379 20.2887 36.7423 20.4392 37.0102 20.707C37.278 20.9749 37.4285 21.3382 37.4285 21.717C37.4285 22.0958 37.278 22.459 37.0102 22.7269C36.7423 22.9947 36.379 23.1452 36.0002 23.1452Z",
    fill: "#3374B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.cb351cb0a2b24ca368a429519654f17d.svg";
export { ForwardRef as ReactComponent };